interface DocsSearchTriggerProps {
  onClick: () => void;
  size?: 'sm' | 'lg';
  className?: string;
}

const SIZE = {
  sm: 'px-3 py-2 text-[13px]',
  lg: 'px-4 py-3.5 text-[15px]',
} as const;

/** 검색창처럼 생긴 버튼. 실제 입력은 ⌘K 다이얼로그가 받는다. */
export function DocsSearchTrigger({
  onClick,
  size = 'sm',
  className = '',
}: DocsSearchTriggerProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center gap-2.5 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-400 transition-colors hover:border-brand-200 dark:border-white/12 dark:bg-white/5 ${SIZE[size]} ${className}`}
    >
      <span aria-hidden>⌕</span>
      문서 검색
      <span className="ml-auto flex gap-1">
        <kbd className="rounded border border-neutral-200 bg-white px-1.5 font-mono text-[10.5px] dark:border-white/15 dark:bg-white/10">
          ⌘
        </kbd>
        <kbd className="rounded border border-neutral-200 bg-white px-1.5 font-mono text-[10.5px] dark:border-white/15 dark:bg-white/10">
          K
        </kbd>
      </span>
    </button>
  );
}
